import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
 } from "@mui/material"

export const Öffnungszeiten = () => {
    function createÖffnungszeiten(
        days: string,
        hours: string
    ) {
        return { days, hours }
    }

    const rows = [
        createÖffnungszeiten("Mo. - Do.", "9 - 18 Uhr"),
        createÖffnungszeiten("Fr.", "9 - 15 Uhr")
    ]
    return (
        <Table
            sx={{
                width: 'auto',
                display: 'inline-table',
                borderCollapse: 'collapse',
                fontSize: "14p"
            }}
            size="small" // <-- reduces default padding
        >
            <TableBody>
                {rows.map((row) => (
                    <TableRow
                        key={row.days}
                        sx={{
                            '& td, & th': { border: 0, height: 'auto' }, // remove padding, auto height
                        }}
                    >
                        <TableCell scope="row" sx={{ p: 0,  fontSize: '1rem' }}>{row.days}</TableCell>
                        <TableCell sx={{ px: 3, py: 0, fontSize: '1rem' }}>{row.hours}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}